import Image from 'next/image'
import styled from 'styled-components'

import { Container } from '@/components/shared/Container'

import { EmailSubscribeWidget } from './EmailSubscribeWidget'

const StyledHeroSection = styled.section`
  margin: 72px auto 0;
  padding: 72px 0 45px 0;

  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    margin-top: 64px;
    padding: 48px 0 24px 0;
  }
`

const StyledContent = styled.div`
  align-items: center;
  display: flex;
  gap: 72px;

  img {
    border-radius: 12px;
    box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
    max-width: 350px;

    @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
      width: 327px;
      max-width: 50%;
    }

    @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
      max-width: 100%;
    }
  }

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    flex-direction: column-reverse;
    gap: 48px;
  }
`

const StyledTextContent = styled.div`
  h1 {
    font-family: ${(p) => p.theme.v2.font.nantes};
    font-size: ${(p) => p.theme.v2.typography.display.xxl.fontSize};
    line-height: ${(p) => p.theme.v2.typography.display.xxl.lineHeight};
    margin: 0;

    @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
      font-size: 42px;
      line-height: 56px;
    }
  }

  p {
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
    font-size: ${(p) => p.theme.v2.typography.body.m.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.m.lineHeight};
    margin: 16px 0 32px;

    @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
      font-size: ${(p) => p.theme.v2.typography.body.s.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.s.lineHeight};
      margin: 16px 0 24px;
    }
  }
`

export const GutShotPageHeroSection = () => {
  return (
    <StyledHeroSection>
      <Container>
        <StyledContent>
          <StyledTextContent>
            <h1>
              Get the <em>free</em> ZOE <em>gut health</em> guide
            </h1>
            <p>
              Take the first step towards improving your gut health with an exclusive series of emails and recipes, all
              backed by world-leading science.
            </p>
            <p>
              We will also send you ongoing gut health and nutrition insights, including how ZOE’s products could help.
            </p>
            <EmailSubscribeWidget includePrivacyPolicy buttonStyle="primary" postSignupMessageStyle="left" />
          </StyledTextContent>
          <Image
            src="/assets/img/gutshot/gut-health.png"
            width={595}
            height={842}
            alt="Gut health made easy. 5 simple steps to a healthier you."
          />
        </StyledContent>
      </Container>
    </StyledHeroSection>
  )
}
